/****************** criteria.js ********* */
// imported into main.js
// functions to control selection and arrangment of
// criteria to select sweet spot
// Returns data str ready to send to api

import { removeItem } from "./utils.js";
import { dragStart, dragEnd, dragOver } from "./dragEvents.js";

const ranked = document.querySelector("#ss-ranked"),
  selectHead = document.querySelector(".ss-selectedHead"),
  // criteriaWrap = document.querySelector("#ss-selector"),
  criteriaSelectedPanel = document.querySelector("#ss-selected"),
  currInputs = Array.prototype.slice.call(
    document.querySelectorAll(".currInput")
  ),
  currSection = document.querySelector("#ss-current"),
  currSuburbInput = document.querySelector("#currSuburb"),
  unrecSuburb = document.querySelector("#unrecognised"),
  //limit = document.querySelector('input[name="limit"]'),
  red100 = "#C2173A",
  optionArray = [
    { dc: "age_dc",
      text: "More young people",
      short: "age",
      id: "1"
    },
    { dc: "vol_dc",
      text: "A helpful community",
      short: "vol",
      id: "2"
    },
    { dc: "div_dc",
      text: "A diverse neighbourhood",
      short: "div",
      id: "3"
    },
    {
      dc: "mao_dc",
      text: "Strong M&#257;ori identity",
      short: "maori",
      id: "4",
    },
    {
      dc: "pt_dc",
      text: "Public transport, walking or cycling options",
      short: "pt",
      id: "5",
    },
    {
      dc: "incr_dc",
      text: "Increasing property values",
      short: "incr",
      id: "6",
    },
    {
      dc: "rent_dc",
      text: "Lower rent compared with nearby areas",
      short: "rent",
      id: "7",
    },
    { dc: "size_dc",
      text: "Larger section size",
      short: "size",
      id: "8" },
    {
      dc: "dep_dc",
      text: "Improving neighbourhood prosperity",
      short: "dep",
      id: "9",
    },
    { dc: "jobs_dc",
      text: "High employment",
      short: "jobs",
       id: "10"
      },
    { dc: "crime_dc",
      text: "Safe neighbourhood",
      short: "crime",
      id: "11"

    },
    { dc: "school_dc",
      text: "Close to schools",
      short: "school",
       id: "12" },
    {
      dc: "acc_dc",
      text: "Close to essential services",
      short: "acc",
      id: "13",
    },
    {
      dc: "hospo_dc",
      text: "Good choice of cafes, bars and restaurants",
      short: "hospo",
      id: "14",
    },
    {
      dc: "coast_dc",
      text: "Close to the coastline",
      short: "coast",
      id: "15",
    },
    { dc: "sun_dc",
      text: "Lots of sunshine",
      short: "sun",
      id: "16"
    },
    { dc: "aff_dc",
      text: "Affordable homes",
      short: "aff",
      id: "17"
    }
  ];

let optionList = document.querySelector("#ss-optionList");

let numRanked = 0; // tracks number of selected criteria

//create send button but do not display yet
let sendBtnContainer = document.createElement("div");
sendBtnContainer.classList.add("sendBtnContainer");
let btnPin = document.createElement("div");
btnPin.classList.add("ss-btnPin");
//btnPin.innerText = '4';
sendBtnContainer.appendChild(btnPin);
let sendBtn = document.createElement("div");
sendBtn.classList.add("ss-sendBtn");
sendBtn.innerText = "Find my Sweet Spot";
sendBtnContainer.appendChild(sendBtn);
//criteriaSelectedPanel.appendChild(sendBtnContainer);

// when a criteria option is clicked
const selectCriteria = (e) => {
  // if user is logged in to MyStuff, let them select criteria
  if (window.loginCheck || window.location.href.includes("localhost")) {
    let selected = e.target,
      checkbox = selected.querySelector("input");

    // activate checkbox
    checkbox.checked = true;
    selected.classList.add("sel-fadeout"); // fade out selected criteria option
    //when fadeout animation has completed, remove option from the full list and add it to the list of selected options
    selected.addEventListener("animationend", () => {
      let opnum = selected.dataset.opnum; // get the slected option number
      removeItem(selected); // remove from the main list
      addRankedItem(opnum); // add it to the selected list
    });
  } else {
    // if user not logged in, show login prompt
    window.doLogin();  // in js/oidc.js
  }
};

const addRankedItem = (opnum) => {
  //create a new list item for the selected option
  let newItem = document.createElement("li"),
    dragger = document.createElement("div"),
    optext = document.createElement("div"),
    closer = document.createElement("div");

  newItem.classList.add("chosen");
  dragger.classList.add("dragger");
  // populate item with option data, then display
  optext.innerHTML = optionArray[opnum].text;
  optext.classList.add("optext");
  closer.classList.add("closer");
  newItem.appendChild(dragger);
  newItem.appendChild(optext);
  newItem.appendChild(closer);
  newItem.setAttribute("draggable", "true");

  //listen for click to remove item from selected list
  closer.addEventListener("click", (e) => {
    let parent = e.target.parentElement;
    parent.classList.add("sel-fadeout");
    parent.addEventListener("animationend", () => {
      let opnum = parent.dataset.opnum;
      removeItem(parent);
      replaceOption(opnum);
    });
  });

  // set option number of new item and display
  newItem.dataset.opnum = opnum;
  newItem.classList.add("sel-fadein");
  ranked.appendChild(newItem);
  numRanked++; // increment number of selected criteria
  checkRanked();

  newItem.addEventListener("animationend", () => {
    newItem.classList.remove("sel-fadein");
  });
  // listen for drag events
  newItem.addEventListener("dragstart", dragStart);
  newItem.addEventListener("dragend", dragEnd);
};

// if criteria is 'deselected' move it back to the main list
const replaceOption = (opnum) => {
  //console.log("here");
  let newItem = document.createElement("li");

  newItem.classList.add("criteriaOption");
  newItem.innerHTML = `<svg class="sidepin" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 61.89 51.28"><defs><style>.b{fill:#c6f7e2;}</style></defs><path class="b" d="M7.51,7.51h0c-10.01,10.01-10.01,26.25,0,36.26h0c10.01,10.01,26.25,10.01,36.26,0l18.13-18.13L43.77,7.51C33.75-2.5,17.52-2.5,7.51,7.51Z"/></svg><input type="checkbox">  ${optionArray[opnum].text}`;
  newItem.addEventListener("click", selectCriteria);
  newItem.dataset.opnum = opnum;
  newItem.classList.add("sel-fadein");
  optionList.appendChild(newItem);
  numRanked--; // decrement number of slected criteria
  checkRanked();

  newItem.addEventListener("animationend", () => {
    newItem.classList.remove("sel-fadein");
  });
};

const checkRanked = () => {
  let options = Array.prototype.slice.call(
      document.querySelectorAll(".criteriaOption")
    ),
    dots = Array.prototype.slice.call(document.querySelectorAll(".ss-cdot")),
    bar = document.querySelector(".ss-cbar");

  numRanked > 0
    ? (document.querySelector(".ss-count").style.display = "flex")
    : (document.querySelector(".ss-count").style.display = "none");

  // set opacity of dots for each criteria selected
  dots.forEach((dot, n) => {
    if (n < numRanked) {
      dot.classList.add("ss-dot-active");
    } else {
      dot.classList.remove("ss-dot-active");
    }
    if (numRanked === 6) {
      bar.classList.add("ss-dot-active");
    } else {
      bar.classList.remove("ss-dot-active");
    }
  });

  ranked.addEventListener("dragover", dragOver);

  if (numRanked === 5) {
    // allow user to submit selected criteria now that we have 5
    if (!document.querySelector(".ss-instruct")) {
      let instruct = document.createElement("div");
      instruct.classList.add("ss-instruct");
      instruct.innerText =
        "Drag the criteria into order of importance, with the most important being at the top.";
      selectHead.appendChild(instruct);
      showSendBtn();
    }
  }

  if (numRanked >= 6) {
    // selecting 6 criteria is allowed - but no more
    // prevent further selections
    options.forEach((option) => {
      option.classList.add("inactive");
    });
  }

  if (numRanked < 6) {
    // less than 6 criteria - allow further selection
    options.forEach((option) => {
      option.classList.remove("inactive");
    });
  }

  if (numRanked < 5) {
    // less than five criteria - do not allow user to submit
    if (document.querySelector(".ss-sendBtn")) {
      removeItem(document.querySelector(".sendBtnContainer"));
    }

    if (numRanked > 0) {
      //show appropriate heading in selected criterai div
      selectHead.innerHTML =
        "<h4>Selected criteria <em>(choose 5 or 6)</em></h4>";
    } else {
      selectHead.innerHTML = "<h4>Selected criteria will appear here</h4>";
    }
  }
};

const compileData = () => {
  // if the 'current spot' data (now just the suburb) has been completed - compile the data
  // currComplete returns true if fields are completed
  if (currComplete()) {
    let chosen = Array.prototype.slice.call(
        document.querySelectorAll(".chosen")
      ),
      limit = document.querySelector('input[name="limit"]:checked').value,
      criteriaStr = "",
      dataStr = "";


    dataStr = `?version=v2022&current_suburb=${currSuburbInput.dataset.sid}&`;
    dataStr += `region=${limit}&`;

    // build url string
    chosen.forEach((item, i) => {
      criteriaStr += `c${i}=${optionArray[item.dataset.opnum].dc}&`;
    });

    //remove trailing '&'
    dataStr += criteriaStr.slice(0, -1);

    /***********  SEND COPY OF CRITERIA TO ADOBE ANALYTICS  ******************* */

    //let digitalData = {};
    window.digitalData = {
      clickTracking: {
        sweetSpotCriteria: dataStr,
      },
    };

    _satellite.track("sweetSpotCriteriaSubmit");
    //console.log(window.digitalData);
    /******************************************************************* */

    // return the compiled search string
    return dataStr;
  } else {
    // show 'curent spot' fields to be completed (suburb)
    currSection.scrollIntoView({ behavior: "smooth", block: "end" });
  }
};

const showSendBtn = () => {
  // sendBtn.classList.add('ss-sendBtn');
  // sendBtn.innerHTML = '<span class="bigNum">4</span> Find my Sweet Spot';
  criteriaSelectedPanel.appendChild(sendBtnContainer);
  //sendBtn.addEventListener('click', compileData);
};

// check if current spot data is conplete - now only suburb
const currComplete = () => {
  let done = true;
  currInputs.forEach((input) => {
    if (input.value === "") {
      //input.style.color = red100;
      input.classList.add("ss-missing");
      done = false;
    }
  });
  if (currSuburbInput.value.length < 3) {
    unrecSuburb.style.display = "block";
    currSuburbInput.style.color = red100;
    done = false;
  }
  if (unrecSuburb.style.display === "block") {
    currSuburbInput.style.color = red100;
    done = false;
  }

  return done;
};

export {
  optionArray,
  selectCriteria,
  addRankedItem,
  replaceOption,
  checkRanked,
  compileData,
  sendBtn,
};
